// // src/pages/OneStepMedi.js
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// /**
//  * EDIT HERE if your backend expects a different endpoint:
//  * - API_URL is the base host (already set to the IP you gave)
//  * - ENDPOINT is appended to API_URL (currently: /promotions)
//  */
// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/onestepmedi'; // change to '/submit', '/api/promotions', etc. if needed

// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     countrycode: '',
//     phoneno: '',
//     phone: '',
//     location: '',
//     promotionType: '',
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     // Basic validation — expand if needed
//     if (!form.name?.trim()) return 'Name is required';
//     if (!form.email?.trim()) return 'Email is required';
//     // lite email pattern
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.countrycode?.trim()) return 'Country code is required';
//     if (!form.phone?.trim()) return 'Phone number is required';
//     if (!form.location?.trim()) return 'Location is required';
//     if (!form.promotionType) return 'Please select a promotion type';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const url = `${API_URL}${ENDPOINT}`;

//       // payload: send exactly the fields required by backend
//       const payload = {
//         name: form.name,
//         email: form.email,
//         country_code: form.countrycode,
//         phoneno: form.phone,
//         location: form.location,
//         promotion_type: form.promotionType,
//       };

//       const resp = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           // Add auth headers here if your API requires them
//         },
//         body: JSON.stringify(payload),
//       });

//       // Accept success: 2xx
//       if (resp.ok) {
//         // try to parse JSON (if backend returns JSON)
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch (e) {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg:
//             data?.message ||
//             'Thank you! Your promotion request has been submitted.',
//         });
//         // clear form
//         setForm({
//           name: '',
//           email: '',
//           countrycode: '',
//           phoneno: '',
//           phone: '',
//           location: '',
//           promotionType: '',
//         });
//       } else {
//         // Try to read error message from backend
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch (e) {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (fetchError) {
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//       console.error('Promotion submit error:', fetchError);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="ONESTEP Promotion Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         ONESTEP Promotion Form
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           type="email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="countrycode"
//           value={form.countrycode}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +91)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phone"
//           value={form.phone}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         {/* SELECT: use visible colors (light bg, dark text) so it’s readable */}
//         <select
//           name="promotionType"
//           value={form.promotionType}
//           onChange={handleChange}
//           required
//           className="w-full p-3 rounded-lg md:col-span-2 appearance-none border border-gray-300 bg-white text-black outline-none"
//         >
//           <option value="">Select Promotion Type</option>
//           <option>Clinic</option>
//           <option>Hospital</option>
//           <option>Doctor</option>
//           <option>Clinic + Doctor</option>
//           <option>Hospital + Doctor</option>
//         </select>
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry
//         purposes.
//       </p>
//     </form>
//   );
// };

// const OneStepMedi = () => {
//   const scrollableRef = useRef(null);
//   const videoRef = useRef(null); // 👈 ref for hero video
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Native scroll + simple parallax
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max(
//             (window.innerHeight - rect.top) /
//               (window.innerHeight + rect.height),
//             0
//           ),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll(); // initial call

//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // scroll-to-top button visibility (existing code kept)
//   useEffect(() => {
//     const btn = document.querySelector('.scrollToTopBtn');
//     const toggle = () =>
//       btn?.classList.toggle('showBtn', window.scrollY > 600);
//     window.addEventListener('scroll', toggle);
//     return () => window.removeEventListener('scroll', toggle);
//   }, []);

//   // Additional scroll listener to compute progress and show/hide the new circular button
//   useEffect(() => {
//     const circumference = 307.919; // matches the strokeDasharray in the SVG
//     const handleProgress = () => {
//       const scrollTop =
//         window.scrollY || document.documentElement.scrollTop;
//       const docHeight =
//         document.documentElement.scrollHeight - window.innerHeight;
//       const progress =
//         docHeight > 0
//           ? Math.min(Math.max(scrollTop / docHeight, 0), 1)
//           : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when the user scrolls back to the top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop =
//         window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from not-top → top
//       if (isAtTop && wasNotAtTop && videoRef.current) {
//         videoRef.current.currentTime = 0; // rewind to start
//         videoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial call

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () =>
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//   return (
//     <>
//       <Helmet>
//         <title>All-in-One Healthcare | Complete Health Management</title>
//         <meta
//           name="description"
//           content="Access comprehensive healthcare services—appointments, records, consultations, and medicine delivery—from one secure mobile platform."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-6xl md:text-8xl font-bold text-white animate-pulse">
//           One Step Medi
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video */}
//       <section className="relative h-screen">
//         <video
//           ref={videoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source
//             src="/video/onestep medi  1.mp4"
//             type="video/mp4"
//           />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//         <div className="relative h-full flex flex-col justify-center items-center text-center text-white px-8"></div>
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* What is One Step Medi? (informational section) */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-6xl md:text-8xl font-extrabold mb-6 text-center">
//               {' '}
//               One Step Medi
//             </h2>
//             <p className="mb-6 text-lg md:text-xl leading-relaxed text-center">
//               All-in-One HealthCare Platform
//             </p>
//             <p className="mb-6 text-lg md:text-xl leading-relaxed">
//               One Step Medi is more than a healthcare platform — it’s your
//               all-in-one digital health companion. It connects patients with
//               trusted doctors, streamlines appointment booking, consolidates
//               prescriptions and reports, and delivers medicine, all from a
//               single secure mobile platform. Whether you need routine care,
//               chronic-condition management, or an urgent consultation, One Step
//               Medi makes healthcare access simple, fast and reliable.
//             </p>
//           </section>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage:
//                     "url('/img/onestepmedi-doctor.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">
//               Instant Access to Doctors
//             </h2>
//             <p className="content__item-description">
//               Search, compare and book appointments with top-rated
//               specialists in a few taps. Fast online consultations and easy
//               scheduling no long waits or phone calls.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage:
//                     "url('/img/onestepmedi-records.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">
//               Digital Health Records
//             </h2>
//             <p className="content__item-description">
//               Securely store prescriptions, test reports and visit history.
//               Share records with doctors for continuity of care and better
//               treatment outcomes.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage:
//                     "url('/img/onestepmedi-family.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">
//               Family Health Management
//             </h2>
//             <p className="content__item-description">
//               Manage care for parents, children and loved ones from a
//               single account appointments, medications and reminders all in
//               one place.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage:
//                     "url('/img/onestepmedi-secure.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">
//               Safe. Secure. Private.
//             </h2>
//             <p className="content__item-description">
//               Bank-level encryption and user-controlled privacy settings
//               ensure your medical data stays private. You control who sees
//               your information.
//             </p>
//           </div>

//           {/* CTA — No extra space after this */}
//           <section className="text-center py-32">
//             <h2 className="text-6xl md:text-9xl font-bold mb-16">
//               Ready for Smarter Healthcare?
//             </h2>
//             <div className="space-x-8">
//               <Link
//                 to="/get-quoted"
//                 className="inline-block bg-blue-600 text-white px-14 py-7 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Book Free Demo
//               </Link>
//               <Link
//                 to="/contact-us"
//                 className="inline-block bg-white text-blue-600 px-14 py-7 rounded-full text-2xl font-bold hover:bg-gray-100 transition transform hover:scale-110"
//               >
//                 Talk to Team
//               </Link>
//             </div>
//           </section>

//           {/* Contact section (form fields as requested) */}
//           <section
//             id="contact"
//             className="py-16 bg-gradient-to-b from-black to-gray-900"
//           >
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Get in touch
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Have a question or want a demo? Send us a message and our
//                 team will get back to you.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer — Directly after content, no black gap */}
//       <Footer />

//       {/* Scroll to Top Button */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg
//           className="w-16 h-16 text-white drop-shadow-2xl"
//           viewBox="0 0 512 512"
//         >
//           <path
//             fill="currentColor"
//             d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z"
//           />
//         </svg>
//       </button>

//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg
//             className="progress-circle -rotate-90 w-12 h-12 absolute"
//             viewBox="-1 -1 102 102"
//           >
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M5 15l7-7 7 7"
//             />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default OneStepMedi;







import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from 'react-router-dom';

/* ===========================================
   CONTACT FORM (Fully merged & UI upgraded)
=========================================== */
const API_URL = "https://api.securxperts.com:8000";
const ENDPOINT = "/forms/onestepmedi";  

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    countrycode: "",
    phone: "",
    location: "",
    promotionType: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const validate = () => {
    if (!form.name?.trim()) return "Name is required";
    if (!form.email?.trim()) return "Email is required";

    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(form.email)) return "Enter a valid email";

    if (!form.countrycode?.trim()) return "Country code is required";
    if (!form.phone?.trim()) return "Phone number is required";
    if (!form.location?.trim()) return "Location is required";
    if (!form.promotionType) return "Please select a promotion type";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    const err = validate();
    if (err) {
      setStatus({ type: "error", msg: err });
      return;
    }

    setSubmitting(true);

    try {
      const url = `${API_URL}${ENDPOINT}`;
      const payload = {
        name: form.name,
        email: form.email,
        country_code: form.countrycode,
        phoneno: form.phone,
        location: form.location,
        promotion_type: form.promotionType,
      };

      const resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (resp.ok) {
        let data = null;
        try {
          data = await resp.json();
        } catch {}

        setStatus({
          type: "success",
          msg:
            data?.message ||
            "Thank you! Your promotion request has been submitted.",
        });

        setForm({
          name: "",
          email: "",
          countrycode: "",
          phone: "",
          location: "",
          promotionType: "",
        });
      } else {
        let errText = `Server responded with ${resp.status}`;
        try {
          const json = await resp.json();
          if (json?.error) errText = json.error;
          else if (json?.message) errText = json.message;
        } catch {}

        setStatus({ type: "error", msg: `Submission failed: ${errText}` });
      }
    } catch (e) {
      setStatus({ type: "error", msg: "Network error. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="form-card max-w-2xl mx-auto bg-white shadow-xl rounded-2xl p-8 border border-gray-200"
    >
      <h3 className="text-3xl font-bold text-center mb-6 text-[#063852]">
        ONESTEP Promotion Form
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="Full Name"
          className="input"
        />

        <input
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          className="input"
        />

        <input
          name="countrycode"
          value={form.countrycode}
          onChange={handleChange}
          placeholder="Country Code (e.g. +91)"
          className="input"
        />

        <input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Phone Number"
          className="input"
        />

        <input
          name="location"
          value={form.location}
          onChange={handleChange}
          placeholder="City, Country"
          className="input md:col-span-2"
        />

        <select
          name="promotionType"
          value={form.promotionType}
          onChange={handleChange}
          className="input bg-white md:col-span-2"
        >
          <option value="">Select Promotion Type</option>
          <option>Clinic</option>
          <option>Hospital</option>
          <option>Doctor</option>
          <option>Clinic + Doctor</option>
          <option>Hospital + Doctor</option>
        </select>
      </div>

      <button className="submit-btn mt-6" disabled={submitting}>
        {submitting ? "Submitting..." : "Submit Promotion Request"}
      </button>

      {status && (
        <p
          className={`text-center mt-4 ${
            status.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {status.msg}
        </p>
      )}

      <p className="text-xs mt-3 text-gray-500 text-center">
        Your details will remain confidential and used only for enquiry
        purposes.
      </p>
    </form>
  );
};

/* ===========================================
   MAIN PAGE
=========================================== */
export default function OneStepMedi() {
  return (
    <div className="w-full font-sans text-[#063852] bg-white">
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="w-full bg-white pt-1 pb-1 px-5 md:px-20 flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2">
          <img src="/img/onestep.png" alt="Logo" className="w-32 mb-1" />

          <h1 className="text-4xl md:text-5xl font-bold leading-snug">
           All-in-One Healthcare Management System 

          </h1>

          <p className="mt-2 text-gray-600 max-w-md">
          An advanced, AI-enabled Hospital Management System built to accelerate complete digital transformation. Streamline clinical workflows, elevate patient care and optimize operations with secure, cloud-based automation. It enhances staff productivity with automated scheduling and digital records, improves decision making through AI-powered insights and real-time alerts and ensures safe, seamless operations with encrypted data and full compliance.

          </p>
        </div>

       <div className="md:w-1/2">
  <img
    src="/img/onestepheroimg.png"
    alt="Hero"
    className="w-full rounded-2xl shadow-lg object-cover object-[center_15%]"
  />
</div>

      </section>

      {/* ================= VIDEO ================= */}
      <section className="w-full py-20 px-3 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/onestepmedi1.mp4"
              muted
              playsInline
              autoPlay
              loop
              preload="auto"
              controls={false}
              key="onestep-video"
              onClick={(e) =>
                e.currentTarget.paused
                  ? e.currentTarget.play()
                  : e.currentTarget.pause()
              }
            />

            <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const v = e.currentTarget
                    .closest("div")
                    .querySelector("video");
                  v.requestFullscreen?.();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl shadow-xl"
              >
                ⛶
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SPECIALTIES ================= */}
      <section className="w-full px-3 md:px-20 py-16 bg-[#f8fbff]">
        <h2 className="text-3xl font-bold text-center mb-10">
          What We Offer

        </h2>

       <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
  {[
    { name: "Pediatrics", icon: "/img/pediatrics.png" },
    { name: "Psychology", icon: "/img/psychology.png" },
    { name: "Daycare", icon: "/img/daycare.png" },
    { name: "Therapy", icon: "/img/therapy.png" },
    { name: "Diagnostics", icon: "/img/diagnostics.png" },
    { name: "Appointments", icon: "/img/appointments.png" },
    { name: "Vaccinations", icon: "/img/vaccinations.png" },
    { name: "Telehealth", icon: "/img/telehealth.png" },
    { name: "Rehabilitation", icon: "/img/rehabilitation.png" },
    { name: "Records", icon: "/img/records.png" },
    { name: "Billing", icon: "/img/billing.png" },
    { name: "Lab Tests", icon: "/img/labtests.png" },
  ].map((item, i) => (
    <div
      key={i}
      className="relative p-6 bg-white rounded-xl text-center shadow-md hover:shadow-xl
      transition-all hover:-translate-y-2 hover:bg-[#e9f6ff]"
    >
      <img
        src={item.icon}
        alt={item.name}
        className="w-10 mx-auto mb-3"
      />
      <p className="font-semibold">{item.name}</p>
    </div>
  ))}
</div>

      </section>

      {/* ================= HIRE TALENT ================= */}
      <section className="w-full px-3 md:px-20 py-20 bg-[#e9f4ff]">
        <div className="flex flex-col md:flex-row items-center gap-10">
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-4">Why Trust Our One Step Medi
</h2>
            <p className="text-gray-600 mb-6 max-w-md">
              At One Step Medi, we provide expert healthcare and child development services through a seamless digital platform. Our system ensures reliable, efficient care while prioritizing patient safety and satisfaction, making us a trusted partner for families and healthcare providers alike

            </p>

            {/* <button className="px-6 py-3 bg-[#063852] text-white rounded-lg hover:bg-[#052c3e]">
              Get Started
            </button> */}
          </div>

          <div className="md:w-1/2">
            <img
              src="/img/img1.png"
              alt="Hiring"
              className="w-full"
            />
          </div>
        </div>
      </section>

      {/* ================= VALUE PROPOSITION ================= */}
      <section className="w-full px-6 md:px-20 py-20 bg-[#f0f7ff]">
        <div className="flex flex-col md:flex-row items-start gap-10">
          <div className="md:w-1/2">
            <img
              src="/img/img2.png"
              alt="Value"
              className="w-full"
            />
          </div>

          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6">Essential Capabilities of Our Healthcare Management System
</h2>

            <ul className="space-y-4 text-gray-700">
              {[
                "Automates clinical, administrative, and financial workflows to save time and reduce errors.",
                "Manages the complete patient journey from registration to follow-ups.",
                "Centralizes appointments, EMR, billing, pharmacy, laboratory, HR, and payroll modules.",
                "Ensures secure storage and protection of sensitive patient data.",
                "Maintains compliance with HIPAA, NABH, and other healthcare regulations.",
                "Supports real-time reporting and analytics for informed decision-making.",
                "Enables telehealth consultations and remote patient monitoring.",
              ].map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-blue-600 text-lg">✔</span> {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="w-full px-6 md:px-2 py-20 bg-white">
        <h2 className="text-3xl font-bold text-center mb-10"> Features of Our All-in-One Healthcare Platform
</h2>

       <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
  {[
    {
      title: "Easy Online Appointment Booking",
      icon: "/img/onlineappointment .png",
    },
    {
      title: "Verified Doctors & Clinics",
      icon: "/img/verifiedclinics.png",
    },
    {
      title: "Advanced Digital Marketing for Doctors",
      icon: "/img/digitalmarketing (1).png",
    },
    {
      title: "Secure Access to Medical History & Reports",
      icon: "/img/medicalhistory.png",
    },
    {
      title: "Personalised Follow-Ups & Reminders",
      icon: "/img/reminders.png",
    },
    {
      title: "All-in-One Platform for Growth",
      icon: "/img/platformforgrowth.png",
    },
  ].map((item, i) => (
    <div
      key={i}
      className="p-6 bg-[#f8fbff] rounded-xl shadow-md text-center"
    >
      <img
        src={item.icon}
        alt={item.title}
        className="w-10 mx-auto mb-3"
      />
      <p className="font-semibold">{item.title}</p>
    </div>
  ))}
</div>

      </section>

      {/* ================= CONTACT FORM ================= */}
      <section className="w-full px-6 md:px-20 py-20 bg-[#f8fbff]">
        <h2 className="text-3xl font-bold text-center mb-8">Get in Touch</h2>
        <ContactForm />
      </section>

      <Footer />
    </div>
  );
}
